import { Response } from '@marketplace-web/core-api/api-client-util'

import {
  BumpAgainSuggestionDto,
  BumpAgainSuggestionModel,
  BumpAgainSuggestionResp,
} from '../types/bump-again-suggestion'

export const transformBumpAgainSuggestion = (
  dto: BumpAgainSuggestionDto,
): BumpAgainSuggestionModel => ({
  soldItemId: dto.sold_item_id,
})

export const transformBumpAgainSuggestionResponse = (
  response: Response<BumpAgainSuggestionResp>,
) => ({
  bumpAgainSuggestion: response.bump_again_suggestion
    ? transformBumpAgainSuggestion(response.bump_again_suggestion)
    : null,
})
